module.exports = __webpack_public_path__ + "img/login_bg.1bc10be1.png";